<template>
  <div class="file-link-uploader-wrap">
    <FileUploader :upload-url="$contextPath(uploadUrl)"
                  :single-file="true"
                  :default-file-list="false"
                  :file-list="uploadList"
                  :disabled="disabled"
                  v-bind="$attrs"
                  @on-success="handleSuccess"
                  @on-error="handleError"
                  @upload-change="handleUploadChange">
      <template #trigger>
        <slot name="trigger"
              :upload-list="uploadList"
              :disabled="disabled">
          <el-button type="default"
                     plain
                     icon="el-icon-upload2"
                     :disabled="disabled">上传文件</el-button>
        </slot>
      </template>
      <template #fileList="scope">
        <slot name="fileList"
              v-bind="scope">
          <div class="file-upload-list">
            <div v-for="(file, index) in scope.fileList"
                 :key="'file-' + index"
                 class="file-item"
                 :class="'status-' + file.status">
              <div class="file-label">
                <div class="title" :title="file.name">
                  <i class="el-icon-paperclip"></i>
                  <a :href="$contextPath(file.url)" target="_blank">{{file.name}}</a>
                </div>
                <div class="close">
                  <i class="el-icon-close"
                     @click="scope.remove(file)"></i>
                </div>
              </div>
              <div class="file-state">
                <template v-if="file.status === 'uploading'">
                  <el-progress :stroke-width="5"
                               :show-text="false"
                               :percentage="file.percentage || 0"></el-progress>
                </template>
              </div>
            </div>
          </div>
        </slot>
      </template>
    </FileUploader>
  </div>
</template>

<script>
import { getValueByPath } from 'element-ui/lib/utils/util'
import FileUploader from '../FileUploader'
export default {
  name: 'FileLinkUploader',
  components: {
    FileUploader
  },
  props: {
    uploadUrl: {
      type: String,
      required: true
    },
    value: {
      type: String
    },
    filename: {
      type: String,
      default: '上传文件'
    },
    resultKey: {
      type: String,
      default: 'uploadLink'
    },
    disabled: Boolean
  },
  data () {
    return {
      uploadList: []
    }
  },
  methods: {
    handleSuccess ({file, result}) {
      const uploadLink = getValueByPath(result, this.resultKey)
      if (uploadLink) {
        file.url = uploadLink
        this.$emit('input', uploadLink)
        this.$emit('handle-success', result)
        this.$message.success(result.message)
      } else {
        this.$message.warning('上传返回结果为空')
      }
    },
    handleError ({error}) {
      this.$emit('input', '')
      this.$message.error(error.message)
    },
    handleUploadChange (fileList) {
      this.uploadList = fileList
    }
  },
  created () {
    if (this.value) {
      let suffixDot = this.value.lastIndexOf('.')
      let getSuffix = suffixDot > 0 ? this.value.substring(suffixDot) : ''
      this.uploadList = [{
        name: this.filename + getSuffix,
        url: this.value
      }]
    }
  },
  watch: {
    value: function (val) {
      if (!val) {
        if (this.uploadList && this.uploadList.length) {
          this.uploadList = []
        }
      }
    },
    uploadList: function (val) {
      if (val && !val.length) {
        this.$emit('input', '')
      }
    }
  }
}
</script>

<style lang="scss">
  .file-link-uploader-wrap {
    .file-uploader-wrap {
      .file-uploader {
        padding: 0;
        .el-upload {
          .el-upload-dragger {
            height: auto;
            border: none;
          }
        }
        .el-button {
          width: 100%;
          border-radius: 0;
          i {
            margin-left: -10px;
          }
        }
      }
      .file-upload-list {
        .file-item {
          &.status- {
            &success {
              & > .file-label {
                & > .title {
                  color: #303133;
                  a {
                    text-decoration: underline;
                  }
                }
              }
            }
          }
          & > .file-label {
            display: flex;
            justify-content: space-between;
            align-items: center;
            & > .title {
              color: #909399;
              font-size: 12px;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
              a {
                color: #909399;
                text-decoration: none;
              }
            }
            & > .close {
              margin-left: 6px;
              color: #909399;
              cursor: pointer;
              &:hover {
                color: #606266;
              }
            }
          }
          & > .file-state {
            margin-top: 2px;
            height: 5px;
            .el-progress {
              .el-progress-bar__outer {
                border-radius: 0;
                .el-progress-bar__inner {
                  border-radius: 0;
                }
              }
            }
          }
          & + .file-item {
            margin-top: 6px;
          }
        }
      }
    }
  }
</style>
